const CONSTANTS = {
  LOADING: "loading",
  FETCHING: "fetching",
  WARNING: "warning",
  PAYMENT_METHOD_CARD: "card",
  PAYMENT_METHOD_TAP: "tap",
  PAYMENT_TAP_CARD: "tap_payment",
  PAYMENT_METHOD_APPLE: "apple_pay",
  ERROR_NO_NUMBER: "no_number_error",
  DROP_OFF_MODAL: "drop-off-modal",
  DROP_OFF_SCREEN: "drop-off-screen",
  ERROR_NUMBER_CONFIRM: "number_commit_error",
  ERROR_PAYMENT_AUTHORIZATION: "payment_auth_error",
  ERROR_MERCHANT_VALIDATION: "merchant_validation_error",
  ERROR_APPLE_PAY: "apple_pay_error",
  APPLE_PAY_FEATURE: "web_apple_pay",
  PC_DEFAULT_MONTH: 1,
  PC_ESIM_SIX_MONTHS_PLUS_PLAN: 6,
  PC_ESIM_SIX_MONTHS_PLUS_PLAN_STR: "6",
  Super45: 1,
  Super70: 2,
  Super100: 3,
  Super150: 4,
  Super215: 5,
  Super380: 6,
  Super215New: 5,
  default_plan: "Super380",
  DESCRIPTION: "description",
  TITLE: "title",
  TOP_UP_NO_LENGHT:10,
  BUILD_VERSION: "0.1",
  TOP_UP_NUMBER_LENGTH:10
};

export default CONSTANTS;
